var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSymbol(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 180,
    viewBox: "0 0 180 180",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M164.616 82.2621H149.232V97.6459H164.616V82.2621Z",
    fill: "#FF3B4B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4759 97.7379H30.8598L30.8598 82.3541H15.4759L15.4759 97.7379Z",
    fill: "#218CE7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M137.349 31.781L148.219 20.911L159.089 31.781L148.219 42.651L137.349 31.781ZM126.479 42.651L20.911 148.219L31.781 159.089L137.349 53.6131L126.479 42.7431V42.651Z",
    fill: "#218CE7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M82.262 15.476V30.8598H97.6459V15.476L82.262 15.476Z",
    fill: "#218CE7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M97.6459 164.524V149.14H82.262V164.524H97.6459Z",
    fill: "#FF3B4B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8651 42.6981L42.7431 53.5761L53.6211 42.6981L42.7431 31.8201L31.8651 42.6981Z",
    fill: "#FF3B4B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M180 82.2621H164.616V97.6459H180V82.2621Z",
    fill: "#233B4B"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3838 82.2621H0V97.6459H15.3838V82.2621Z",
    fill: "#233B4B"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M97.6459 0H82.262V15.3838H97.6459V0Z",
    fill: "#233B4B"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M97.6459 164.616H82.262V180H97.6459V164.616Z",
    fill: "#233B4B"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8372 20.9029L20.9592 31.7809L31.8372 42.6589L42.7152 31.7809L31.8372 20.9029Z",
    fill: "#233B4B"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M148.197 137.341L137.319 148.219L148.197 159.097L159.075 148.219L148.197 137.341Z",
    fill: "#233B4B"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M137.349 126.387L108.608 97.738H149.232V82.2621H97.738V30.8598H82.262V71.392L53.6131 42.7431L42.7431 53.6131L71.392 82.2621H30.8598V97.738H82.262V149.232H97.738V108.608L126.387 137.349L137.349 126.387Z",
    fill: "#233B4B"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M148.227 137.338L137.349 126.46L126.471 137.338L137.349 148.216L148.227 137.338Z",
    fill: "#218CE7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbol);
export default __webpack_public_path__ + "static/media/symbol.adda6a99000ab39be604bfaf463179c5.svg";
export { ForwardRef as ReactComponent };